import { render } from "./DiligansFooter.vue?vue&type=template&id=4f7261cf&scoped=true"
import script from "./DiligansFooter.vue?vue&type=script&lang=js"
export * from "./DiligansFooter.vue?vue&type=script&lang=js"

import "./DiligansFooter.vue?vue&type=style&index=0&id=4f7261cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7261cf"]])

export default __exports__